export default __webpack_public_path__ + "static/media/year_white.ef5cdbd6.svg";